/**
 * SEO Module - Updates meta tags and structured data dynamically
 */
import { escapeHtml } from './utils.js';

/**
 * Updates all relevant head tags and titles based on the provided news data.
 * @param {Object} data - The parsed news data containing at least a 'hero' array.
 * @param {string} [dateStr='today'] - The date string representing the current edition.
 * @returns {void}
 */
export function updateSEO(data, dateStr = 'today') {
  if (!data || !data.hero || !data.hero[0]) return;

  const mainTitle = data.hero[0].title;
  const dateFormatted = dateStr === 'today' ? '' : ` (${dateStr})`;
  const newTitle = `Resumen Digital${dateFormatted} — ${mainTitle}`;
  
  // 1. Update <title>
  document.title = newTitle;

  // 2. Update Meta Description
  const metaDesc = document.querySelector('meta[name="description"]');
  if (metaDesc) {
    const newDesc = `${dateStr === 'today' ? 'Hoy' : 'Edición ' + dateStr}: ${data.hero[0].title}. ${data.hero[0].subtitle}`;
    metaDesc.setAttribute('content', newDesc.substring(0, 160));
  }

  // 3. Update OG Tags
  const ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle) ogTitle.setAttribute('content', newTitle);
  
  const ogDesc = document.querySelector('meta[property="og:description"]');
  if (ogDesc) ogDesc.setAttribute('content', data.hero[0].subtitle);

  const ogImage = document.querySelector('meta[property="og:image"]');
  if (ogImage && data.hero[0].image) {
    const imgSrc = data.hero[0].image.startsWith('http') ? data.hero[0].image : window.location.origin + '/' + data.hero[0].image;
    ogImage.setAttribute('content', imgSrc);
  }

  // 4. Update Canonical Link
  const canonical = document.querySelector('link[rel="canonical"]');
  if (canonical) {
    let cleanPath = window.location.pathname;
    if (cleanPath === '/py' || cleanPath === '/py/' || cleanPath === '/index.html') {
      cleanPath = '/';
    }
    const newUrl = window.location.origin + cleanPath + (dateStr === 'today' ? '' : '?date=' + dateStr);
    canonical.setAttribute('href', newUrl);
  }
}

/**
 * Update NewsArticle schema (mainly for noticia.html)
 * @param {Object} noticia - The specific news item object.
 * @param {string} absUrl - The absolute URL of the current news article.
 * @param {string} dateParam - The date the article was published.
 * @returns {void}
 */
export function updateNewsSchema(noticia, absUrl, dateParam) {
  const schemaScript = document.getElementById('schemaNewsArticle');
  if (!schemaScript || !noticia) return;

  try {
    const schema = JSON.parse(schemaScript.innerHTML);
    schema.mainEntityOfPage["@id"] = absUrl;
    schema.headline = noticia.title;
    schema.image = [noticia.image];
    schema.datePublished = dateParam;
    schema.dateModified = dateParam;
    schemaScript.innerHTML = JSON.stringify(schema);
  } catch (e) {
    console.warn("Error updating schema", e);
  }
}
